export default __webpack_public_path__ + "static/media/web-development.c641bc77.jpg";